<template>
	<div class="flex flex-col p-3 text-sm min-w-[160px] gap-1">
		<div class="border-b border-b-solid border-b-gray-200 mb-1 pb-2">
			<strong>{{translate("entities.user")}}</strong>
			<div
				class="flex flex-row items-center gap-2 rounded p-2  mt-1 "
				:class="{'hover:bg-gray-100 cursor-pointer': $isAllowed('update user')}"
				@click="$isAllowed('update user') && updateUser()"
			>
				<span class="grow">{{ activeUser?.name }}</span>
			</div>
		</div>
		<div
			v-if="companies.length > 0"
			class="border-b border-b-solid border-b-gray-200 mb-1 pb-2"
		>
			<strong>{{translate("entities.plural.company")}}</strong>
			<div
				v-for="{ id, name } in companies"
				:key="id"
				v-close-popper
				class="flex flex-row items-center gap-2 rounded p-2 hover:bg-gray-100 mt-1 cursor-pointer"
				:class="{
          'bg-green-100 hover:bg-green-100 font-bold text-green-600':
            id == activeCompany?.id
        }"
				@click="switchCompany(id)"
			>
        <span class="grow">
          {{ name }}
        </span>
			</div>
		</div>
		<div
			v-close-popper
			class="item"
			@click="openMfaSetup"
		>
			<span class="grow"> {{translate("common.user-settings-menu.two-factor-authentication")}} </span>
			<AppIcon
				icon="fa-key"
				class="text-primary"
			/>
		</div>
		<div
			v-close-popper
			class="item"
			@click="attemptLogout"
		>
			<span class="grow"> {{translate("common.user-settings-menu.log-out")}} </span>
			<AppIcon
				icon="fa-right-from-bracket"
				class="text-primary"
			/>
		</div>
	</div>
</template>

<script setup lang="ts">
import { Company, logout, setActiveCompany } from "@q-food/q-food";
import { useUserStore } from "~stores/User";
import { translate } from "~/plugins/I18n.ts";

const props = defineProps<{
	companies: Company[];
}>();

const { companies } = toRefs(props);
const { setToken } = useUserStore();
const { push } = useRouter();

const { activeCompany, activeUser } = storeToRefs(useUserStore());

async function switchCompany(id: string) {
	if (id == activeCompany.value?.id) return;

	await setActiveCompany(id);
	window.location.reload();
}

function openMfaSetup() {
	push("/security/otp-setup");
}

async function attemptLogout() {
	await logout();
	setToken(null);
}

async function updateUser() {
	push(`/user/update/${activeUser.value?.id}`);
}
</script>

<style scoped>
.item {
	@apply p-2.5  hover:text-primary cursor-pointer flex flex-row justify-between items-center;
}
</style>
